module.exports = __webpack_public_path__ + "static/media/bg_itinerary.6be5c313.png";